module.exports = __webpack_public_path__ + "img/seo_bling.e8dbd7e.webp";